<template>
  <v-container>

    <v-row class="text-center pt-5 pl-10 pr-10">
      <v-col cols="12">
        <h1>エラー</h1>
      </v-col>
      <v-col cols="12">
        {{ errormessage }}
      </v-col>
      <v-col cols="12">
        QRコードを<br />再度読み取ってください
      </v-col>
    </v-row>
  </v-container>

</template>
<script>
export default {
  data: () => ({
    errormessage: ""
  }),
  created: function () {
    if (this.$route.params.errormessage) {
      this.errormessage = this.$route.params.errormessage;
    }
  }
}
</script>
